import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import fetch from 'cross-fetch';
import { Configuration } from '../../config';


function GenericVideoDisplayFunction({settings}) { 


    const [showGenericVideoDisplay, setGenericVideoDisplay] = useState({});

    const crpModalCloseButton = {
        backgroundColor: '#0161aa'

    };

    const downloadButton = {
        backgroundColor: '#0161aa',
        color: 'white',
        padding: '10px 20px',
        border: 'none',
        cursor: 'pointer',
        textDecoration: 'none',
        fontSize: '20px',
    };

    let pathName = window.location.pathname;

    let searchSlug = pathName.substring(pathName.lastIndexOf('/') +1 );

    const HtmlDisplay = (props) => {
        return (
            <p dangerouslySetInnerHTML={{__html: props.html}} />
          );
    };


    useEffect(() => {

        fetch(Configuration.rootUrl+'/api/delivery/projects/website/entries/search?accessToken=' + Configuration.accessToken, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                pageIndex: 0,
                pageSize: 1,
                where: [
                    {
                        field: 'sys.versionStatus',
                        equalTo: 'published'
                    },
                    {
                        field: 'sys.contentTypeId',
                        equalTo: 'Videos'
                    },
                    {
                        field: 'sys.slug',
                        equalTo: searchSlug
                    }

                ]
                })
            })
            .then(response => response.json())
            .then(data => {

                setGenericVideoDisplay(data.items[0]);
                //console.log(data.items[0].imOnlyVideos.sys.uri);

            })
            .catch(error => console.error(error));


    }, []);

    const isAuthGenericVideoDisplay = () => {
        if (showGenericVideoDisplay.imOnlyVideos) {
            
            return (
                <div className="row" >
                    <div className="large-12 column">

                        <div className="video-description"> 
                            <HtmlDisplay html={showGenericVideoDisplay.videoDescription} />               
                        </div>

                        <a href={'https://twi-global.com'+showGenericVideoDisplay.imOnlyVideos.sys.uri} style={downloadButton} ><i className="fas fa-arrow-down"></i> Download Webinar</a>

                        
                    </div>
                </div>
            );
        } else {
            return null;
        }


    };

    const nonMemberModal = () => {

        let crpVideoReturnUrl = "/what-we-do/research-and-technology/research-programmes/core-research-programme/crp-media-and-events/crp-videos/" + searchSlug;
        let crpVideoUrl = "/what-we-do/research-and-technology/research-programmes/core-research-programme/crp-media-and-events/crp-videos.aspx";

        return (
          <div role="dialog" aria-hidden="false" className="dialog" id="inline-modal-qP9jVToXCUw" >
              <div className="dialog__window" id="dialog-window-qP9jVToXCUw" role="document">
                  <header role="banner">
                      <a href={crpVideoUrl} id="close-modal-button-qP9jVToXCUw" aria-label="Close Dialog" className="btn btn--modal-back" style={crpModalCloseButton}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon"><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-close-white"></use></svg>
                          <span className="visuallyhidden">Close Dialog</span>
                      </a>
                  </header>
                  <div className="paywall-message" >
                    <p>Hi,<br /></p>

                    <p>This content is for TWI Industrial Members only.</p>

                    <p>If you are an employee of a TWI Industrial Member company 
                        please <a href={`/account/Login.aspx?ReturnURL=${crpVideoReturnUrl}`}>login here</a> to view the video.</p>

                    <p>To find out more information about this project or TWI Industrial Membership please <a href="mailto:contactus@twi.co.uk">contact us</a>.</p>

                  </div>
              </div>
              <div className="dialog__mask"></div>
          </div>
  
  
        );

  
  
    };


return (
    <div className='twi-jobs'> 
        {settings && settings.isAuth ? isAuthGenericVideoDisplay() : nonMemberModal()}
    </div>
);
}


GenericVideoDisplayFunction.propTypes = {
    entries: PropTypes.object,
    html: PropTypes.string,
    settings: PropTypes.object
};

const mapStateToProps = state => (
    { 
        entries: getEntries(state), 
        search: getSearch(state), 
        filters: getFilters(state), 
        settings: getSettings(state) 
    });

export default connect(mapStateToProps)(GenericVideoDisplayFunction);

